import React,{useState,useRef,useEffect,useCallback} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import {resetPopupNotification} from '../../../../app/action'
import renderHTML from 'react-render-html'

let PopupNotification = (props) =>{
  const {popupNotification} = useSelector(state=>({popupNotification: state.app.popupNotification}))
  const {className} = props
  const { status, data, error } = popupNotification
  const [fadeout,setFadeout] = useState(false)
  const dispatch = useDispatch();
  const t = useRef(null)

  const closeCallback = useCallback(()=>{
      setFadeout(true)
      if(t.current){
        window.clearTimeout(t)
      }
      t.current = window.setTimeout(()=>{
        resetPopupNotification(dispatch)
        setFadeout(false)
      },300)
  },[t,dispatch])
  useEffect(()=>{
    if(status==="success" || status==="error"){
      if(t.current){
        window.clearTimeout(t)
      }
      if(!fadeout){
        t.current = window.setTimeout(()=>{
          closeCallback()
        },8000)
      }


    }
  },[status,fadeout,closeCallback])
  if(status === 'error' && error && error.data && error.data.errors){
    const renderErrors = () => {
      if(error.data.errors.length > 0){
        return error.data.errors.map((item,index)=>{
          const {details} = item
          return (
            <div key={index} className={'of-popup-notification__item'}>
              {renderHTML(details)}
            </div>
          )
        })
      }
    }
    return (
      <div className={`of-popup-notification${className?' '+className:''} status-background-2-100${fadeout?' of-popup-notification--fadeout':''}`}>
        <div className={'of-popup-notification__wrapper'}>
          {renderErrors()}
        </div>
        <button className={'of-popup-notification__close'} onClick={e=>{
          e.preventDefault()
          closeCallback()
        }}><i className={'icon icon-of-blog-close'} /></button>
      </div>
    )
  }
  if(status === "success" && data && data.message){
    return (
      <div className={`of-popup-notification${className?' '+className:''} status-background-1-100${fadeout?' of-popup-notification--fadeout':''}`}>
        <div className={'of-popup-notification__wrapper'}>
          <div className={'of-popup-notification__item'}>{data.message}</div>
        </div>
        <button className={'of-popup-notification__close'} onClick={e=>{
          e.preventDefault()
          closeCallback()
        }}><i className={'icon icon-of-blog-close'} /></button>
      </div>
    )
  }

  return(<></>)
}

PopupNotification.propTypes = {
  status: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.any,
  data: PropTypes.any
}

export default PopupNotification